import { createFeatureSelector } from '@ngrx/store';
import { AllCustomersState } from '../models/all-customers.models';
import { MemberInfoActionsState, MembersInfoState, MembersSummaryState } from '../models/member-summary.models';
import { MembersSearchState } from '../models/members-search.models';
import { SharedState } from '../models/shared.models';
import { CustomerInfoState } from './customer-info.reducer';
import { CustomerSummaryState } from './customer-summary.reducer';
import { AllCustomersReducer } from './all-customers.reducer';
import { CustomerInfoReducer } from './customer-info.reducer';
import { CustomerSummaryReducer } from './customer-summary.reducer';
import { MemberInfoActionsReducer } from './member-info-actions.reducer';
import { MemberInfoReducer } from './member-info.reducer';
import { MemberSummaryReducer } from './member-summary.reducer';
import { MembersSearchReducer } from './members-search.reducer';
import { SharedReducer } from './shared.reducer';

export const featureCustomersName = 'Customers';

export interface DragonflyCustomersState {
  shared: SharedState;
  memberSearch: MembersSearchState;
  allCustomers: AllCustomersState;
  memberInfo: MembersInfoState;
  memberInfoActions: MemberInfoActionsState;
  memberSummary: MembersSummaryState;
  customerInfo: CustomerInfoState;
  customerSummary: CustomerSummaryState;
}

export const moduleCustomersReducers = {
  shared: SharedReducer,
  memberSearch: MembersSearchReducer,
  allCustomers: AllCustomersReducer,
  memberInfo: MemberInfoReducer,
  memberInfoActions: MemberInfoActionsReducer,
  memberSummary: MemberSummaryReducer,
  customerInfo: CustomerInfoReducer,
  customerSummary: CustomerSummaryReducer,
};

export const getDragonflyCustomersState = createFeatureSelector<DragonflyCustomersState>(featureCustomersName);
